import { policyTypes } from '@ourbranch/policy-types';

import { illustrationForPolicyType } from 'core/components/illustrated-loader/policy-type-illustration';
import { getOpenPolicies } from 'customer/components/workspace/workspace-summary';

export const GENERIC_ART = 'generic';
export const HOME_AUTO_ART = 'homeauto';

// The loader shows home art for a home and auto bundle; the nav has a scene with both.
const artForType = (type) =>
  (type === policyTypes.HABundle ? HOME_AUTO_ART : illustrationForPolicyType(type)) ?? GENERIC_ART;

// The household's open lines: home and auto → both; one line → its art; any other mix → the property line.
const householdArt = (policies) => {
  const open = getOpenPolicies(policies);
  const lines = [...new Set(open.map(({ policyType }) => policyType))];
  const homeAndAuto = lines.length === 2 && lines.includes(policyTypes.Home) && lines.includes(policyTypes.Auto);
  return {
    art: homeAndAuto
      ? HOME_AUTO_ART
      : artForType(lines.length === 1 ? lines[0] : lines.find((type) => type !== policyTypes.Auto)),
    umbrella: open.some((policy) => policy.policyDetails?.includeUmbrella)
  };
};

const policyArt = (policy) => ({
  art: artForType(policy?.policyType),
  umbrella: Boolean(policy?.policyDetails?.includeUmbrella)
});

// The quote can keep includeUmbrella while an auto- or renters-only option is selected; umbrella rides on home or condo.
const offerArt = ({ selectedOption, includeUmbrella }) => ({
  art: artForType(selectedOption),
  umbrella:
    Boolean(includeUmbrella) && [policyTypes.Home, policyTypes.Condo].some((type) => selectedOption.includes(type))
});

// Which art the nav shows for the current page, or null while that page's customer or offer is still loading.
export const getNavArt = ({ accountId, policyId, offerId, account, offerStore }) => {
  if (accountId) {
    if (account?.id !== accountId || !account.policies || account.policies.loading) {
      return null;
    }
    const policies = account.policies.list ?? [];
    return policyId ? policyArt(policies.find(({ id }) => id === policyId)) : householdArt(policies);
  }
  if (offerId) {
    const { offer, selectedOption } = offerStore ?? {};
    if (offer?.id !== offerId || !selectedOption) {
      return null;
    }
    return offerArt({ selectedOption, includeUmbrella: offer.quote?.includeUmbrella });
  }
  return { art: GENERIC_ART, umbrella: false };
};
